export default __webpack_public_path__ + "static/media/blurb_border.34ffb0f2.svg";